import glamorous from 'glamorous';
import React from 'react';
import { createPureComponent } from 'module/Common';

const SvgColors = glamorous.svg({
  '& g': {
    fill: '#1D1D1B',
  },
  '&:hover g': {
    fill: '#0077B5',
  },
});

export const LinkedInIcon = createPureComponent('LinkedInIcon', () => (
  <SvgColors width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="A4" transform="translate(-379 -394)">
        <path
          d="M404.0869,419.4686 L399.7319,419.4686 L399.7319,412.6496 C399.7319,411.0236 399.7009,408.9316 397.4669,408.9316 C395.1989,408.9316 394.8509,410.7026 394.8509,412.5316 L394.8509,419.4686 L390.4959,419.4686 L390.4959,405.4456 L394.6769,405.4456 L394.6769,407.3616 L394.7339,407.3616 C395.3159,406.2596 396.7379,405.0966 398.8579,405.0966 C403.2719,405.0966 404.0869,408.0016 404.0869,411.7776 L404.0869,419.4686 Z M385.5839,403.5296 C384.1879,403.5296 383.0569,402.3966 383.0569,401.0016 C383.0569,399.6076 384.1879,398.4756 385.5839,398.4756 C386.9779,398.4756 388.1099,399.6076 388.1099,401.0016 C388.1099,402.3966 386.9779,403.5296 385.5839,403.5296 L385.5839,403.5296 Z M383.4049,419.4686 L387.7629,419.4686 L387.7629,405.4456 L383.4049,405.4456 L383.4049,419.4686 Z M406.2569,394.4296 L381.2169,394.4296 C380.0199,394.4296 379.0479,395.3786 379.0479,396.5476 L379.0479,421.6936 C379.0479,422.8636 380.0199,423.8136 381.2169,423.8136 L406.2569,423.8136 C407.4549,423.8136 408.4319,422.8636 408.4319,421.6936 L408.4319,396.5476 C408.4319,395.3786 407.4549,394.4296 406.2569,394.4296 L406.2569,394.4296 Z"
          id="Fill-7"
        />
      </g>
    </g>
  </SvgColors>
));



// WEBPACK FOOTER //
// ./src/module/View/Menu/icons/LinkedInIcon.tsx